import moment from "moment";

export class DatesUtils {
    static rangeToDateStrings(range:moment.Moment[], format = 'YYYY-MM-DD'){
        const [start, end] = range;

        if (!start || !end){
            return undefined;
        } else {
            return [start.format(format), end.format(format)];
        }
    }
    static dateStringsToRange(range:string[]){
        const [start, end] = range;
        return [moment(start), moment(end)];
    }
}
